import React, { useState, useEffect, useRef } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { listAuditInventoriesByAccount } from "../../../graphql/inventory/custom-queries";

import { TextField, Typography, Button, Grid, Avatar } from "@material-ui/core";
import { orange, amber, grey, green, blueGrey } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import { getNextItem } from "./Audit";
import CrewCard from "../../../components/common/CrewCard";

const useStyles = makeStyles((theme) => ({
  locationContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  locationItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  locationAvatar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: theme.spacing(9.5),
    height: theme.spacing(9.5),
    color: theme.palette.text.primary,
    backgroundColor: blueGrey[100],
    margin: theme.spacing(1),
  },
  locationSelectedAvatar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: theme.spacing(9.5),
    height: theme.spacing(9.5),
    boarder: "2px solid black",
    color: theme.palette.getContrastText(orange[100]),
    backgroundColor: orange[100],
    margin: theme.spacing(1),
  },
  locationCompletedAvatar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: theme.spacing(9.5),
    // color: theme.palette.text.primary,
    color: theme.palette.getContrastText(green[200]),
    height: theme.spacing(9.5),
    backgroundColor: green[200],
    margin: theme.spacing(1),
  },
  locationButtonCenter: {
    display: "flex",
    justifyContent: "center",
    margin: theme.spacing(2),
  },

  orange: {
    color: theme.palette.getContrastText(orange[100]),
    backgroundColor: orange[100],
  },
  green: {
    color: theme.palette.getContrastText(green[200]),
    backgroundColor: green[200],
  },
  amber: {
    color: theme.palette.getContrastText(amber[500]),
    backgroundColor: amber[500],
  },
  unprocessedItem: {
    color: theme.palette.getContrastText(grey[300]),
    backgroundColor: grey[300],
  },
  backToInventory: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(4),
  },
  selectAccount: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  notFound: {
    display: "fles",
    margin: theme.spacing(2),
  },
}));

const YardLocations = ({
  locations,
  buttonLabel,
  handleLocation,
  handleCancel,
  currentAudit,
  accounts,
  disableAccounts,
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(currentAudit.accountName);
  const [inputValue, setInputValue] = useState("");
  const [allAccounts, setAllAccounts] = useState([]);
  const [accountLocations, setAccountLocations] = useState(locations);
  const isComponentMounted = useRef(true);

  useEffect(() => {
    isComponentMounted &&
      setAllAccounts([
        "All accounts",
        ...accounts.map((acct) => acct.businessName),
      ]);
    return () => (isComponentMounted.current = false);
  }, [accounts]);

  const selectLocation = (idx) => {
    handleLocation(idx);
  };

  const getAvatarClassName = (idx) => {
    const location = locations[idx];
    if (
      (!inputValue || inputValue === "All accounts") &&
      idx === getNextItem(currentAudit)
    ) {
      return classes.locationSelectedAvatar;
    } else if (
      currentAudit.processedLocations[location] &&
      currentAudit.processedLocations[location].completed >=
        currentAudit.processedLocations[location].total
    ) {
      return classes.locationCompletedAvatar;
    } else return classes.locationAvatar;
  };

  const setSelectedAccount = async (newValue) => {
    debugger;
    if (!newValue || newValue === "All accounts") {
      setAccountLocations(locations);
      return;
    }
    setValue(newValue);
    const response = await API.graphql(
      graphqlOperation(listAuditInventoriesByAccount, {
        reloadYardId: window.appUser?.reloadYardId,
        statusAccountNameProductNameLotNumber: {
          beginsWith: { status: "STORED", accountName: newValue },
        },
        limit: 500,
      })
    );
    const accountInventories =
      response.data.inventoryByStatusByAccountByProductByLot.items;
    const locationValues = {};
    debugger;

    accountInventories.forEach((itm) => {
      if (itm.location) locationValues[itm.location.id] = itm.location;
    });
    setAccountLocations(Object.keys(locationValues));
  };

  return (
    <CrewCard
      title="Yard locations"
      icon={<LocationOnOutlinedIcon fontSize="large" />}
    >
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md={4}>
          <div className={classes.selectAccount}>
            <Autocomplete
              value={value}
              disabled={disableAccounts || value !== "All accounts"}
              onChange={(event, newValue) => {
                setSelectedAccount(newValue);
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              id="accounts"
              fullWidth
              options={allAccounts}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select account"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </div>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            {accountLocations.length === 0 ? (
              <Typography className={classes.notFound}>
                No inventories found for {value}.
              </Typography>
            ) : (
              accountLocations.map((location, idx) => (
                <div
                  key={window.appUser.reloadYard.locationMap[location].id}
                  className={classes.locationItem}
                >
                  <Avatar
                    variant={
                      (!inputValue || inputValue === "All accounts") &&
                      idx === getNextItem(currentAudit)
                        ? "circular"
                        : "rounded"
                    }
                    className={getAvatarClassName(idx)}
                    onClick={() => selectLocation(idx)}
                  >
                    <Typography>
                      {window.appUser.reloadYard.locationMap[location].name}
                    </Typography>
                  </Avatar>
                </div>
              ))
            )}
          </div>
        </Grid>
      </Grid>
      <div className={classes.locationButtonCenter}>
        <Button size="large" color="primary" onClick={() => handleCancel()}>
          {buttonLabel}
        </Button>
      </div>
    </CrewCard>
  );
};

export default YardLocations;
